import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "Offers", path: "/offers" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-navy/98 backdrop-blur-md border-b border-white/5 shadow-lg"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/eede9e94d3823189d88ba59164d5c11f/168c55980e2a35b55b08471421fd7088.png"
            alt="RESECOR logo"
            className="h-8 md:h-9 w-auto object-contain"
          />
          <span className="font-heading font-bold text-sm md:text-base tracking-[0.2em] text-white whitespace-nowrap">
            RESECOR
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`font-body text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                location.pathname === link.path
                  ? "text-copper"
                  : "text-mid-grey hover:text-white"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="ml-2 px-5 py-2 border border-copper text-copper hover:bg-copper hover:text-white transition-all duration-200 font-body text-sm font-medium tracking-wide cursor-pointer whitespace-nowrap rounded-sm"
          >
            Start a Conversation
          </Link>
        </nav>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer text-mid-grey hover:text-white"
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl`} />
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden bg-navy/98 backdrop-blur-md border-t border-white/5 overflow-hidden transition-all duration-300 ${
          mobileOpen ? "max-h-80 py-4" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col px-6 gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`font-body text-sm font-medium py-3 border-b border-white/5 cursor-pointer whitespace-nowrap ${
                location.pathname === link.path
                  ? "text-copper"
                  : "text-mid-grey hover:text-white"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="mt-3 px-5 py-2.5 border border-copper text-copper text-center font-body text-sm font-medium cursor-pointer whitespace-nowrap rounded-sm"
          >
            Start a Conversation
          </Link>
        </nav>
      </div>
    </header>
  );
}
